<ion-header class="ion-no-border">

    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button (click)="close()">
                <fa-icon [icon]="['far', 'times']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
            </ion-button>
        </ion-buttons>
        <ion-title>Searching for printers ...</ion-title>
        <ion-buttons slot="end">
			<ion-button>
				<fa-icon [icon]="['fal', 'spinner-third']" size="lg" animation="spin"></fa-icon>
			</ion-button>
		</ion-buttons>
    </ion-toolbar>

</ion-header>

<ion-content>

    <div>
        <ion-list *ngIf="printers && printers.length != 0">
            <ion-item *ngFor="let printer of printers; let i = index" lines="full" button="true" (click)="select(i)">
                <ion-label>
                    <h3>{{printer.modelName}}</h3>
                    <p>{{printer.portName}}</p>
                </ion-label>
            </ion-item>
        </ion-list>
    </div>

</ion-content>

